import { render, staticRenderFns } from "./PlanoCurricular.vue?vue&type=template&id=53199e37&"
import script from "./PlanoCurricular.vue?vue&type=script&lang=js&"
export * from "./PlanoCurricular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports